<template>
    <div class="text-center p-4">
        <p class="text-dark mb-4 fw-bold">{{ formattedNextDraw }}</p>

        <!-- Prizes -->
        <div class="result-card p-3 rounded-3 mx-auto" style="max-width: 400px; background: #f4f6fa;">
            <div v-for="(prize, index) in prizeKeys" :key="index" class="mb-4">
                <div class="fw-bold text-secondary mb-2" style="font-style: italic;">
                    {{ prizeTitles[index] }}
                </div>
                <div class="d-flex justify-content-center">
                    <div v-for="(digit, i) in prizeDigits(prize)" :key="i" class="result-ball mx-1">
                        <div class="p-1 result-ball-inside">{{ digit }}</div>
                    </div>
                </div>
                <hr class="my-2" style="border-top: 2px solid #ffc107; width: 80%; margin: auto;">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardResult',
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    computed: {
        prizeKeys() {
            return ['result', 'result2', 'result3'];
        },
        prizeTitles() {
            return ['First Place', 'Second Place', 'Third Place'];
        },
        formattedNextDraw() {
            const raw = this.result.datetime;
            if (!raw) {
                return `Period: ${this.result.period}`;
            }
            const date = new Date(raw);
            const options = {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };
            const formatted = date.toLocaleString('en-US', options);
            const parts = formatted.split(', ');
            const [weekday, dateStr] = parts;
            const time = parts[2];
            return `${weekday}, ${dateStr} | ${time} Period: ${this.result.period}`;
        },
        prizeDigits() {
            return (key) => this.result[key]?.split('') ?? [];
        }
    }
};
</script>

<style scoped>
/* .result-ball {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffc107;
    display: flex;
    align-items: center;
    justify-content: center;
}

.result-ball-inside {
    background: white;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
} */
</style>